<template>
  <div>
    <template v-if="$store.getters.selectedTab=='xstore'">
      <div class="btn-group-hdr">
        <div class="btn-group btn-group-toggle">
          <!--<button v-if="images.length>0" type="button" class="btn btn-secondary btn-sm" @click="removeAllImages" data-toggle="tooltip" data-placement="bottom" title="Remove All Images"><i class="fas fa-times"></i>&nbsp;Remove All</button>-->
          <!--<button v-if="images.length>0" type="button" class="btn btn-secondary btn-sm" @click="searchImages" data-toggle="tooltip" data-placement="bottom" title="Search Image"><i class="fas fa-file-upload"></i>&nbsp;Search</button>-->
        </div>
      </div>

      <div class="title-hdr bg-dark">
        XStore Download Mobile Apps
      </div>

      <!--<div class="progress" v-if="progressing">
        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
      </div>-->

      <div class="card">
        <div class="card-body">
          <div class="container-fluid container-fluid-max">
            <div class="row text-center">
              <div class="col-12 pb-4 pt-5">
                <h2 class="text-red"><img src="static/images/Xstore_JmxLogo.png" style="height: 50px; width: 120px;">&nbsp;&nbsp;Download Below</h2>
              </div>
              <div class="col-12 col-sm-6 col-lg-4">
                <a :href="'itms-services://?action=download-manifest&url='+baseUrl+'/downloads/xstore/Info.plist'"><img src="static/icons/ios.png" style="height: 100px; width: 100px;"></a>
                <h3 class="mt-3 text-red h4">XStore IOS</h3>
                <p>Download Application Certificate Below </p>
                <template v-for="cert in certs.ios">
                  <p><a :href="baseUrl+'/downloads/xstore/certificates'+cert.filepath" download>{{ cert.name }}</a></p>
                  <!-- <p @click="downloadCert(cert.filepath)">{{ cert.name }}</p> -->
                </template>
              </div>
              <div class="col-12 col-sm-6 col-lg-4">
                <a :href="baseUrl+'/downloads/xstore/Xstore.apk'" download><img src="static/icons/android.png" style="height: 100px; width: 100px;"></a>
                <h3 class="mt-3 text-red h4">XStore Android</h3>
                <p>Download Application Certificate Below </p>
                <template v-for="cert in certs.android">
                  <p><a :href="baseUrl+'/downloads/xstore/certificates'+cert.filepath" download>{{ cert.name }}</a></p>
                  <!-- <p @click="downloadCert(cert.filepath)">{{ cert.name }}</p> -->
                </template>
              </div>
              <div class="col-12 col-sm-6 col-lg-4">
                <a href="javascript:void(0)" download><img src="static/icons/windows.png" style="height: 100px; width: 100px;"></a>
                <h3 class="mt-3 text-red h4">XStore Windows</h3>
                <p>Download Application KeyStore Below </p>
                <template v-for="cert in certs.windows">
                  <p><a :href="baseUrl+'/downloads/xstore/certificates'+cert.filepath" download>{{ cert.name }}</a></p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
//  import certs from "../../../downloads/xstore/certificates/certs.json";

  import axios from 'axios'
  import { baseUrl } from './../../../.env.js'
  import { bus } from '../../../main.js'

  export default {
    name: 'XStore',
    data() {
      return {
        certs: {},
        baseUrl : baseUrl
      }
    },
    mounted() {
    var vm = this;
    $.getJSON(baseUrl+"/downloads/xstore/certificates/certs.json", function(data){
      vm.certs = data;
    });
      console.log(baseUrl)
      //this.$store.commit('selectedTab', 'xstore');
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/mobileapps/main/XStore.vue